import React, { useEffect, useState } from "react";
import "./CookieBanner.css";

const CONSENT_KEY = "pdfconvert_cookie_consent"; // "accepted" | "rejected"

function injectAdsenseOnce(clientId) {
  if (!clientId) return;
  if (document.querySelector('script[data-adsbygoogle="true"]')) return;

  const s = document.createElement("script");
  s.async = true;
  s.src = `https://pagead2.googlesyndication.com/pagead/js/adsbygoogle.js?client=${encodeURIComponent(
    clientId
  )}`;
  s.crossOrigin = "anonymous";
  s.setAttribute("data-adsbygoogle", "true");
  document.head.appendChild(s);
}

/** Consent Mode v2 helpers */
function grantConsent() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "granted",
      analytics_storage: "granted",
    });
  }
}

function denyConsent() {
  if (typeof window !== "undefined" && typeof window.gtag === "function") {
    window.gtag("consent", "update", {
      ad_storage: "denied",
      analytics_storage: "denied",
    });
  }
}

export default function CookieBanner({ adsenseClientId = "" }) {
  const [visible, setVisible] = useState(false);

  useEffect(() => {
    const saved = localStorage.getItem(CONSENT_KEY);

    if (saved === "accepted") {
      // Respect the saved choice
      setVisible(false);
      grantConsent();
      injectAdsenseOnce(adsenseClientId);
      return;
    }

    if (saved === "rejected") {
      setVisible(false);
      denyConsent();
      return;
    }

    // No choice yet -> show banner
    setVisible(true);
  }, [adsenseClientId]);

  const accept = () => {
    localStorage.setItem(CONSENT_KEY, "accepted");
    setVisible(false);

    grantConsent();
    injectAdsenseOnce(adsenseClientId);
  };

  const reject = () => {
    localStorage.setItem(CONSENT_KEY, "rejected");
    setVisible(false);

    denyConsent();
  };

  const resetConsent = () => {
    localStorage.removeItem(CONSENT_KEY);
    setVisible(true);

    // Reset to denied by default
    denyConsent();
  };

  if (!visible) {
    // Small button to reopen the banner anytime
    return (
      <button className="cookie-manage" onClick={resetConsent} type="button">
        Cookies
      </button>
    );
  }

  return (
    <div
      className="cookie-backdrop"
      role="dialog"
      aria-modal="true"
      aria-label="Gestion des cookies"
    >
      <div className="cookie-banner">
        <div className="cookie-title">Gestion des cookies</div>

        <p className="cookie-text">
          Nous utilisons des cookies pour mesurer l’audience et afficher des
          publicités (Google AdSense). Vos fichiers restent{" "}
          <b>100% traités localement</b> (aucun envoi). Vous pouvez accepter ou
          refuser.
        </p>

        <div className="cookie-actions">
          <button
            className="cookie-btn cookie-secondary"
            onClick={reject}
            type="button"
          >
            Refuser
          </button>
          <button
            className="cookie-btn cookie-primary"
            onClick={accept}
            type="button"
          >
            Accepter
          </button>
        </div>

        <div className="cookie-links">
          <a href="#/confidentialite">Politique de confidentialité</a>
        </div>
      </div>
    </div>
  );
}
